import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MessageCircle } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contatti" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#141414]">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#FFCC00] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
            Contatti
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Hai bisogno di aiuto?
          </h2>
          <p className="text-gray-400 text-lg mb-12 max-w-2xl mx-auto">
            Il nostro team è disponibile per rispondere a qualsiasi domanda. 
            Contattaci tramite WhatsApp per una risposta immediata.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="https://wa.me/393773781602"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp"
              className="inline-flex items-center gap-3 bg-[#25D366] text-white font-bold px-8 py-4 hover:bg-[#20BD5A] transition-all duration-200"
            >
              <MessageCircle className="w-6 h-6" />
              WhatsApp
            </a>
            <a
              href="tel:+393773781602"
              data-testid="contact-phone"
              className="inline-flex items-center gap-3 bg-transparent text-white border border-white/20 hover:border-[#FFCC00] hover:text-[#FFCC00] px-8 py-4 transition-all duration-200"
            >
              <Phone className="w-6 h-6" />
              +39 377 378 1602
            </a>
            <a
              href="mailto:unlockbags@gmail.com"
              data-testid="contact-email"
              className="inline-flex items-center gap-3 bg-transparent text-white border border-white/20 hover:border-[#FFCC00] hover:text-[#FFCC00] px-8 py-4 transition-all duration-200"
            >
              <Mail className="w-6 h-6" />
              Email
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;
